// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BorderLeftOutlinedSvg from "@ant-design/icons-svg/es/asn/BorderLeftOutlined";
import AntdIcon from '../components/AntdIcon';

var BorderLeftOutlined = function BorderLeftOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BorderLeftOutlinedSvg
  }));
};

BorderLeftOutlined.displayName = 'BorderLeftOutlined';
export default React.forwardRef(BorderLeftOutlined);